import React, { useEffect, useRef, useState } from "react";
import SectionMagazine12 from "components/Sections/SectionMagazine12";
import { BACKEND_URL } from "../../../constants";
//

const PageGetNewsletters = () => {
  const [newsletters,setNewsletters] = useState([])
  let user = sessionStorage.getItem("user")
  const initialized = useRef(false);
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      fetch(`${BACKEND_URL}/get-newsletters`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (!response.hasOwnProperty("error")) {
           setNewsletters(response.result)
          }
        })
        .catch((error) => {
          console.error("error: ", error);
        })
        .finally(() => {
          console.log("finally")
        })
    }
  }, [newsletters]);

  return (
    <div className="nc-PageHomeDemo6 relative [ nc-section-rounded-md ]">
      <div className="relative overflow-hidden">
        <div className="container relative">
        <h1 style={{marginTop:"50px",marginBottom:"50px"}} className="text-2xl md:text-3xl lg:text-4xl font-semibold">Spis newsletterów</h1>
        <table style={{marginBottom:"30px"}} className="newsletters-table">
        <tr>
          <th>Identyfikator</th>
          <th>Adres e-mail</th>
              </tr>
          {newsletters.map((newsletter, index) => {
            return(
              <tr key={newsletter?.id}>
                <td>{index + 1}</td>
                <td>{newsletter?.email}</td>
              </tr>
            )
          })}
        </table>
        </div> 
      </div>
    </div>
  );
};

export default PageGetNewsletters;
